import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaseViewModel from "./../../factories/base-view-model";
import baoDialog from "./../../factories/bao-dialog";
import TranslateDialog from "./../../factories/translate-dialog";
import "./../../bindings/bao-number-box";
function FieldViewModel(tabPage) {
    var self = this;
    BaseViewModel.call(self, tabPage);
    self.FieldName = ko.pureComputed({
        read: function () {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    return self.FieldName1();
                case 2:
                    return self.FieldName2();
                case 3:
                    return self.FieldName3();
                case 4:
                    return self.FieldName4();
                case 5:
                    return self.FieldName5();
            }
        },
        write: function (value) {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    self.FieldName1(value);
                    break;
                case 2:
                    self.FieldName2(value);
                    break;
                case 3:
                    self.FieldName3(value);
                    break;
                case 4:
                    self.FieldName4(value);
                    break;
                case 5:
                    self.FieldName5(value);
                    break;
            }
        }
    });
    self.FieldName1 = ko.observable();
    self.FieldName2 = ko.observable();
    self.FieldName3 = ko.observable();
    self.FieldName4 = ko.observable();
    self.FieldName5 = ko.observable();
    self.TranslateField = function () {
        var translateDialog = new TranslateDialog(self.FieldName1, self.FieldName2, self.FieldName3, self.FieldName4, self.FieldName5);
        translateDialog.Open().then(function () { });
    };
}
Bao.inherit(FieldViewModel, BaseViewModel);
FieldViewModel.prototype.PrimaryKey = "FieldId";
FieldViewModel.prototype.RefreshUrl = "Checkware/Field/GetField";
FieldViewModel.prototype.SaveUrl = "Checkware/Field/SaveField";
FieldViewModel.prototype.DeleteUrl = "Checkware/Field/DeleteField";
FieldViewModel.prototype.PermissionRefresh = "FieldRefresh";
FieldViewModel.prototype.PermissionSave = "FieldSave";
FieldViewModel.prototype.PermissionDelete = "FieldDelete";
FieldViewModel.prototype.CompleteCheck = function () {
    var self = this;
    var isCompleted = true;
    if (Bao.Utils.String.IsNullOrWhitespace(self.FieldName())) {
        isCompleted = false;
    }
    if (Bao.Utils.String.IsNullOrWhitespace(self.FieldTypeId())) {
        isCompleted = false;
    }
    if (Bao.Utils.String.IsNullOrWhitespace(self.MatchCode())) {
        isCompleted = false;
    }
    if (isCompleted == false) {
        new baoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
    }
    return isCompleted;
};
export default FieldViewModel;